/** Valores de catálogo sin `active` se tratan como activos (compat). */
export function isCatalogAttributeValueActive(
  value: { active?: boolean | null } | null | undefined
): boolean {
  return value?.active !== false;
}

export function filterActiveCatalogAttributeValues<T extends { active?: boolean | null }>(
  values: readonly T[] | null | undefined
): T[] {
  if (!values?.length) {
    return [];
  }
  return values.filter((value) => isCatalogAttributeValueActive(value));
}
